<template>
  <div class="unauthorized-container">
    <div class="unauthorized-content">
      <div class="icon-container">
        <i class="fas fa-lock"></i>
      </div>
      <h1>Unauthorized Access</h1>
      <p v-if="isStaging">You don't have permission to access this page. Please login to continue.</p>
      <p v-else>You don't have permission to access this page.</p>
      <router-link v-if="isStaging" to="/login" class="login-button">
        Go to Login
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnauthorizedView',
  computed: {
    isStaging() {
      return import.meta.env.VITE_ENV === 'staging'
    }
  }
}
</script>

<style scoped>
.unauthorized-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.unauthorized-content {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.icon-container {
  font-size: 64px;
  color: #dc3545;
  margin-bottom: 20px;
}

h1 {
  color: #333;
  margin-bottom: 16px;
  font-size: 24px;
}

p {
  color: #666;
  margin-bottom: 24px;
  font-size: 16px;
}

.login-button {
  display: inline-block;
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.login-button:hover {
  background-color: #0056b3;
}
</style> 